<template>
  <h3 v-if="text">{{ text }}</h3>
  <div>
    <label v-if="files.length > 0">
      Добавленные файлы:
      <div class="files-list" v-for="(file, index) of files" :key="index">
        <div>{{ file.file_name }}
          <img src="@/profile/assets/icons/close_btn_red.svg" @click="delFiles(index)" alt="">
        </div>
      </div>
    </label>
    <div v-if="errors.length > 0" class="errors">
      <div v-for="(error, key) in errors" :key="key" class="error">
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "MakcFilesComponent",
  props: {
    text: {
      type: String,
      default: "Добавьте файлы"
    }
  },
  emits: ["load"],
  data() {
    return {
      file_valid_types: [
        "doc",
        "docx",
        "rtf",
        "txt",
        "bmp",
        "jpg",
        "jpeg",
        "gif",
        "png",
        "zip",
        "rar",
        "xls",
        "xlsx",
        "pdf"
      ],
      errors: [],
      files: []
    };
  },
  methods: {
    delFiles(i) {
      this.files.splice(i, 1);
    },
    loadFiles(event) {
      // console.log(`loadFiles, ${event}`);
      for (let i = 0; i < event.target.files.length; i++) {
        let type_arr = event.target.files[i].name.split(".");
        if (!this.file_valid_types.includes(type_arr[type_arr.length - 1].toLowerCase())) {
          this.errors = [];
          this.errors.push("Недопустимый фомат файла");
          return;
        } else {
          this.errors = [];
        }
        this.getBase64(event.target.files[i]).then(
          data => this.files.push({
            file_name: event.target.files[i].name,
            mime: event.target.files[i].type,
            file_data: data,
            file_size: event.target.files[i].size
          }));
        this.$emit("load", this.files);
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    }
  }
};
</script>

<style scoped>
</style>